import { initialState as OrderSearchTDState } from '../modules/orderSearchTD';

export const select = (state) => state.orderSearch || OrderSearchTDState;


export const selectErrorStatus = (state) => select(state).errorStatus;
export const selectErrorType = (state) => select(state).errorType;

